
import { PropTypes } from 'prop-types';
import { NavLink } from 'react-router-dom';
import { DecodeHtml } from '../../utils/decodeHtml';
const Program = ({ title, description, programmes }) => {
    return (
        <div className='flex flex-col gap-4'>
            <h1 className='text-3xl font-bold leading-normal'>{title}</h1>
            <p className="w-auto  2xl:max-w-7xl text-justify   text-opacity-70 text-base font-normal  leading-normal">{DecodeHtml({html:description})}</p>
            <div className="flex flex-col gap-4">
                {programmes?.length > 0 && programmes?.map((program, index) => (
                    <NavLink key={index} to
                        ={program?.link} className=" text-xl font-bold  leading-normal">{program?.name}</NavLink>
                ))}
            </div>

        </div>
    )
}
Program.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    programmes: PropTypes.array
}
export default Program